import { TextData } from 'src/app/shared/interfaces';

export const standards: { [key: string]: TextData } = {
  '1837': {
    text: 'The student is expected to edit drafts using standard English conventions, including prepositions and prepositional phrases.',
  },
  '2560': {
    text: 'The student is expected to edit drafts using standard Spanish conventions, including prepositions and prepositional phrases.',
  },
};
